import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-redeem-thank-you-popup',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './redeem-thank-you-popup.component.html',
    styleUrl: './redeem-thank-you-popup.component.scss',
})
export class RedeemThankYouPopupComponent {
    constructor(
        private dialogRef: MatDialogRef<RedeemThankYouPopupComponent>
    ) {}

    closeDialog() {
        this.dialogRef.close();
    }
}
